<section class="auction-support-card">
  <div class="auction-support-card__icon-wrap">
    <i class="iconsax auction-support-card__icon" icon-name="headphones"></i>
  </div>

  <div class="auction-support-card__content">
    <h3 class="auction-support-card__title">
      {{ 'auctions.negotiationsQuestion' | translate }}
    </h3>
    <p class="auction-support-card__subtitle">
      {{ 'auctions.agentsRespond247' | translate }}
    </p>
  </div>

  <a [href]="contactLink" target="_blank" rel="noopener noreferrer">
    <pwj-button variant="primary" size="medium">
      {{ 'auctions.contactAgent' | translate }}
    </pwj-button>
  </a>
</section>
